/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_PrivacyInputs */



/**
* | output |
* | --- |
* | "Privacy" |
*
* @param {Footer_PrivacyInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const footer_privacy = /** @type {((inputs?: Footer_PrivacyInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_PrivacyInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("Privacy")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Sekretess")
	return /** @type {LocalizedString} */ ("Personvern")
});